import React, {useCallback, useEffect, useMemo, useState, useRef} from "react"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import {Autocomplete, Box, Grid, Paper, Typography} from "@mui/material"
import ClearIcon from '@mui/icons-material/Clear'
import {ReactComponent as SearchIcon} from "src/v2/assets/icons/search-icon.svg"
import {ReactComponent as ChatIcon} from "src/v2/assets/icons/chat-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import {ReactComponent as TrashIcon} from "src/v2/assets/icons/trash-icon.svg"
import {ReactComponent as FileIcon} from "src/v2/assets/icons/file-icon.svg"
import {ReactComponent as PlusSquareIcon} from "src/v2/assets/icons/plus-square-icon.svg"
import TextFieldInput from "../../components/Input/text-field-input"
import ButtonWithIcon from "../../components/Button/Button"
import GridRadioButton from "../../components/radio-button/grid-radio-button"
import DataGridTable from "../../components/Table/data-grid-table"
import {useNavigate} from "react-router-dom"
import {MOTOR_CADASTRO_MANUAL_PAGE} from "src/utils/routes"
import {createColumnsCadastroMotor, createColumnsOCR} from "./cadastro-motor-const"
import MotorService from "../../../services/motor-service"
import PromptService from "../../../services/prompt-service"
import {dispatchSnackbar} from "../../components/SnackBar/snackbar-bus"
import DuplicarModal from "./duplicar-modal"
import EditarPromptModal from "./editar-prompt-modal"
import FormSectionAccordion from "../../components/FormSectionAccordion"
import StatusBadge from "../../components/StatusBadge"
import {dispatchDuplaConfirmacao} from "../../components/DuplaConfirmacao/DuplaConfirmacaoBus"

const TITLE_MOTOR_LIST_PAGE = "Cadastro de Operações"

const TIPO_DOCUMENTO_MAP = {
    "a": "Termo de securitização",
    "b": "TelaCetipCorporate",
    "c": "TelaCetipIF",
    "d": "EscrituraDebenture",
    "e": "OutrasEscrituras",
    "f": "FluxoEventos"
}

const MotorCadastroListPage = () => {
    const [cetipInput, setCetipInput] = useState("")     // texto digitado
    const [cetipValue, setCetipValue] = useState("")  // CETIP selecionado

    const [versaoDocumentoValue, setVersaoDocumentoValue] = useState("")
    const [versoesDocumentoOptions, setVersoesDocumentoOptions] = useState([])

    const [listaPromptsBackend, setListaPromptsBackend] = useState([])
    const [promptAtual, setPromptAtual] = useState("")
    const [tipoSelecionado, setTipoSelecionado] = useState("")
    const [modalEditarOpen, setModalEditarOpen] = useState(false)
    const [promptFinalEnvio, setPromptFinalEnvio] = useState("")

    const [ocrFile, setOcrFile] = useState(null)
    const fileInputRef = useRef(null)
    const [loadingTableOCR, setLoadingTableOCR] = useState(false)
    const [rowsOCR, setRowsOCR] = useState([])
    const [ocrStatus, setOcrStatus] = useState([])

    const [loadingTable, setLoadingTable] = useState(false)
    const [rows, setRows] = useState([])

    const pagination = {page: 0}
    const navigate = useNavigate()
    const service = useMemo(() => new MotorService(), [])
    const promptService = useMemo(() => new PromptService(), [])
    const [cetipError, setCetipError] = useState(false)

    const [modalDuplicarOpen, setModalDuplicarOpen] = useState(false)
    const [linhaSelecionada, setLinhaSelecionada] = useState(null)

    const [autoCompleteOptions, setAutoCompleteOptions] = useState([])
    const [autoCompleteLoading, setAutoCompleteLoading] = useState(false)

    const [loadingVersoes, setLoadingVersoes] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)

    useEffect(() => {
        loadCadastrosEmAndamento()
        loadCadastrosOCR()
    }, [])

    useEffect(() => {
        promptService.getPrompts()
            .then((response) => {
                const resultados = response.body?.results || []
                setListaPromptsBackend(resultados)
            })
            .catch(() => {
                dispatchSnackbar("Erro ao carregar tipos de documentos OCR", "error")
            })
    }, [promptService])

    const handleRadioChange = (event) => {
        const valorRadio = event.target.value
        setTipoSelecionado(valorRadio)

        setPromptFinalEnvio("")


        const nomeTipoBack = TIPO_DOCUMENTO_MAP[valorRadio]

        const promptEncontrado = listaPromptsBackend.find(
            item => item.TipoDocumento === nomeTipoBack
        )

        if (promptEncontrado) {
            setPromptAtual(promptEncontrado.Prompt)
        } else {
            setPromptAtual("")
        }
    }

    const handleAbrirModal = () => {
        if (!tipoSelecionado) {
            dispatchSnackbar("Selecione um tipo de documento primeiro.", "warning")
            return
        }
        if (!promptAtual && !promptFinalEnvio) {
            dispatchSnackbar("Não existe prompt base para editar.", "warning")
            return
        }
        setModalEditarOpen(true)
    }

    const handleFecharModal = () => {
        setModalEditarOpen(false)
    }

    const handleSalvarModal = (novoPrompt) => {
        setPromptFinalEnvio(novoPrompt)
        setModalEditarOpen(false)
        dispatchSnackbar("Prompt atualizado para envio!", "success")
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0]
        if (file) {
            setOcrFile(file)
        }
    }

    const handleDrop = (event) => {
        event.preventDefault()
        const file = event.dataTransfer.files[0]
        if (file) {
            setOcrFile(file)
        }
    }

    const handleRemoveFile = () => {
        setOcrFile(null)
        if (fileInputRef.current) {
            fileInputRef.current.value = ""
        }
    }

    const handleTriggerFileSelect = () => {
        fileInputRef.current.click()
    }


    const handleUploadOCR = () => {
        if (!ocrFile) {
            dispatchSnackbar("Selecione um arquivo para enviar.", "warning")
            return
        }

        if (!cetipValue) {
            dispatchSnackbar("Informe o CETIP no filtro superior.", "warning")
            return
        }
        if (!versaoDocumentoValue) {
            dispatchSnackbar("Informe a Versão do Documento no filtro superior.", "warning")
            return
        }

        if (!tipoSelecionado) {
            dispatchSnackbar("Selecione o Tipo de Documento.", "warning")
            return
        }

        const promptParaEnviar = promptFinalEnvio || promptAtual

        const formData = new FormData()
        formData.append("Arquivo", ocrFile)
        formData.append("CETIP", cetipValue)
        formData.append("VersaoDocumento", versaoDocumentoValue)
        formData.append("TipoDocumento", TIPO_DOCUMENTO_MAP[tipoSelecionado])

        if (promptParaEnviar) {
            formData.append("Prompt", promptParaEnviar)
        }

        setLoadingPage(true)
        service.postUploadOcr(formData)
            .then(() => {
                dispatchSnackbar("Arquivo enviado com sucesso!", "success")

                setOcrFile(null)
                setTipoSelecionado("")
                setPromptFinalEnvio("")
                if (fileInputRef.current) fileInputRef.current.value = ""
                loadCadastrosOCR()
            })
            .catch((err) => {
                console.error("Erro ao enviar arquivo OCR:", err)

                const body = err?.response?.body ?? err?.body
                const detail =
                    typeof body === "string"
                        ? body
                        : body != null
                            ? JSON.stringify(body)
                            : (err?.message || "Detalhes indisponíveis")

                dispatchSnackbar(`Erro ao enviar arquivo OCR: ${detail}`, "error")
            })
            .finally(() => {
                setLoadingPage(false)
            })
    }

    const debounceRef = useRef(null)
    const lastRequestIdRef = useRef(0)

    const handleDuplicarCadastro = useCallback((row) => {
        setLinhaSelecionada(row)
        setModalDuplicarOpen(true)
    }, [])

    const loadCetipSuggestions = (value) => {
        if (value.length < 4) {
            setAutoCompleteOptions([])
            return
        }

        clearTimeout(debounceRef.current)

        debounceRef.current = setTimeout(() => {
            const requestId = ++lastRequestIdRef.current
            setAutoCompleteLoading(true)

            service.loadCadastros(value, null)
                .then((response) => {
                    if (requestId !== lastRequestIdRef.current) return

                    const cetips = (response.body ?? [])
                        .map(item => item.CETIP)
                        .filter(Boolean)

                    setAutoCompleteOptions([...new Set(cetips)])
                })
                .catch(() => {
                    if (requestId === lastRequestIdRef.current) {
                        setAutoCompleteOptions([])
                    }
                })
                .finally(() => {
                    if (requestId === lastRequestIdRef.current) {
                        setAutoCompleteLoading(false)
                    }
                })
        }, 300)
    }

    const loadCadastros = (cetip, versao) => {
        setLoadingTable(true)
        service.loadCadastros(cetip, versao)
            .then((response) => {
                const {body} = response
                const list = body.map((obj, index) => ({...obj, id: index}))
                setRows(list)
            })
            .catch(() => {
                dispatchSnackbar("Erro ao carregar os registros!", "error")
            })
            .finally(() => {
                setLoadingTable(false)
            })
    }

    const loadCadastrosEmAndamento = async () => {
        setLoadingTable(true)
        try {
            const response = await service.loadCadastros(null, null)

            const list = (response.body ?? [])
                .filter(item => item.Status === "Em andamento")                             
                .sort((a, b) => {
                    if (a.CETIP !== b.CETIP) {
                        return a.CETIP.localeCompare(b.CETIP)
                    }
                    return Number(a.VersaoDocumento) - Number(b.VersaoDocumento)
                })
                .map((obj, index) => ({ ...obj, id: index }))

            setRows(list)
        } catch {
            dispatchSnackbar("Erro ao carregar os registros!", "error")
        } finally {
            setLoadingTable(false)
        }
    }


    const loadCadastrosOCR = () => {
        setLoadingTableOCR(true)
        service.loadCadastrosOCR()
            .then((response) => {
                const {body} = response
                const list = body.map((obj, index) => ({...obj, id: index}))
                setRowsOCR(list)

                const statusCount = list.reduce(
                    (acc, {Status}) => {
                        acc[Status] = (acc[Status] || 0) + 1
                        return acc
                    },
                    {
                        READING: 0,
                        DONE: 0,
                        ERROR: 0,
                    }
                )

                setOcrStatus([
                    {color: "warning", label: "Em andamento", number: statusCount.READING},
                    {color: "#2BCE95", label: "Leitura concluída", number: statusCount.DONE},
                    {color: "error", label: "Erros", number: statusCount.ERROR},
                ])
            })
            .catch(() => {
                dispatchSnackbar("Erro ao carregar os registros do OCR!", "error")
            })
            .finally(() => {
                setLoadingTableOCR(false)
            })
    }

    const loadVersoesDocumento = (cetipSelecionado) => {
        if (!cetipSelecionado || cetipSelecionado.length < 4) {
            setVersoesDocumentoOptions([])
            setVersaoDocumentoValue("")
            return
        }

        setLoadingVersoes(true)

        service.loadCadastros(cetipSelecionado)
            .then((response) => {
                const registros = response.body ?? []

                const registrosDoCetipSelecionado = registros.filter(
                    item => item.CETIP === cetipSelecionado
                )

                const versoesUnicas = [
                    ...new Set(
                        registrosDoCetipSelecionado.map(item => item.VersaoDocumento)
                    )
                ]

                setVersoesDocumentoOptions(versoesUnicas)
            })
            .catch(() => {
                setVersoesDocumentoOptions([])
            })
            .finally(() => {
                setLoadingVersoes(false)
            })
    }

    const filterCadastro = () => {
        setRows([]) 
        if (cetipValue === null || cetipValue === "") {
            setCetipError(true)
            dispatchSnackbar("Necessário informar o CETIP", "warning")
            return
        }
        setCetipError(false)
        loadCadastros(cetipValue, versaoDocumentoValue)
    }

    const iniciaCadastroManual = () => {
        const cetipParaEnviar = cetipValue || cetipInput

        console.log("CETIP VISUAL:", cetipInput)
        console.log("CETIP SELECIONADO:", cetipValue)
        console.log("CETIP ENVIADO:", cetipParaEnviar)

        navigate(MOTOR_CADASTRO_MANUAL_PAGE, {
            state: {
                cetip: cetipParaEnviar,
                versaoDocumento: versaoDocumentoValue
            }
        })
    }


    const handleVerCadastro = useCallback(
        (row) => {
            const cetip = row?.CETIP
            const versao = row?.VersaoDocumento
            const id = row?.ID
            if (!cetip) {
                dispatchSnackbar("CETIP inválido para visualização", "warning")
                return
            }
            navigate(MOTOR_CADASTRO_MANUAL_PAGE, {
                state: {cetip, versaoDocumento: versao, id},
            })
        },
        [navigate]
    )

    const handleRegisterOCR = (ocrID) => {
        console.log(ocrID) // todo chamar a tela de cadastro via OCR
    }

    const removeOCR = (id) => {
        setLoadingTableOCR(true)
        service.deleteCadastroOCR(id)
            .then(() => {
                dispatchSnackbar("Cadastro de OCR removido com sucesso", "success")
            })
            .catch((error) => {
                dispatchSnackbar(`Erro ao eliminar o cadastro do OCR: ${error}`, "error")
            })
            .finally(() => {
                setLoadingTableOCR(false)
                loadCadastrosOCR()
            })
    }

    const handleDeleteOCR = (ocrID) => {
        dispatchDuplaConfirmacao({
            title: "Excluir cadastro de OCR",
            open: true,
            confirmAction: () => removeOCR(ocrID),
        })
    }

    const columns = useMemo(
        () => createColumnsCadastroMotor(handleVerCadastro, handleDuplicarCadastro),
        [handleVerCadastro, handleDuplicarCadastro]
    )

    const columnsOCR = useMemo(
        () => createColumnsOCR(handleRegisterOCR, handleDeleteOCR),
        [handleRegisterOCR, handleDeleteOCR]
    )

    const handleConfirmarDuplicacao = (dadosDoModal) => {
        const row = dadosDoModal.original

        let dadosAntigosTratados = {}

        if (row.ID) {
            dadosAntigosTratados = {id: row.ID}
        } else {
            dadosAntigosTratados = {
                cetip: row.CETIP,
                versaoDocumento: row.VersaoDocumento
            }
        }

        const payload = {
            origem: 'duplicacao',
            dadosAntigos: dadosAntigosTratados,
            novosDados: {
                cetip: dadosDoModal.novoCetip,
                versao: dadosDoModal.novaVersao
            }
        }

        console.log("Redirecionando com payload corrigido:", payload)

        navigate(MOTOR_CADASTRO_MANUAL_PAGE, {state: payload})
        setModalDuplicarOpen(false)
    }

    const versoesDocumentoSelectOptions = versoesDocumentoOptions.map((versao) => ({
        value: versao,
        label: String(versao),
    }))

    const ocrStatusBadge = (number, label, color) => (
        <Box
            sx={{
                ml: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
            }}
        >
            <StatusBadge
                label={`${number}`}
                radius={1}
                backgroundColor={color}
                fontColor="primary"
            />
            <Typography
                variant="body2"
                color="common.white"
                sx={{
                    ml: 1,
                    fontSize: 14,
                    fontWeight: 400,
                }}
            >
                {label}
            </Typography>
        </Box>
    )

    // estilo para o upload
    const dashedAreaStyle = {
        width: '100%',
        border: '2px dashed #64748b',
        borderRadius: '5px',
        padding: '24px 70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        transition: 'all 0.2s'
    }

    const selectedFileAreaStyle = {
        backgroundColor: 'background.tertiary',
        border: '1px solid #334155',
        padding: '20px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        justifyContent: 'space-between',
        marginTop: '10px',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '100%',
        flexWrap: 'wrap',
    }

    return (
        <SideBarLayout
            title={TITLE_MOTOR_LIST_PAGE}
            header
            loading={loadingPage}
            headerTitle={TITLE_MOTOR_LIST_PAGE}
            headerImage={"/background/cadastro-background-header.jpg"}
        >
            <Box sx={{mt: -2}}>
                <Grid container>
                    <Grid item xs={12} xl={10}>
                        <Paper sx={{p: 3}}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={3} xl={3}>
                                    <Autocomplete
                                        freeSolo
                                        options={autoCompleteOptions}
                                        loading={autoCompleteLoading}
                                        filterOptions={(x) => x}

                                        inputValue={cetipInput}
                                        value={cetipValue}

                                        onInputChange={(event, newInputValue) => {
                                            setCetipInput(newInputValue)
                                            loadCetipSuggestions(newInputValue)

                                            // enquanto digita, limpa versões
                                            setVersoesDocumentoOptions([])
                                            setVersaoDocumentoValue("")
                                            setCetipValue(null)
                                        }}

                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                setCetipValue(newValue)
                                                setCetipInput(newValue)
                                                loadVersoesDocumento(newValue)
                                            }
                                        }}

                                        renderInput={(params) => (
                                            <TextFieldInput
                                                {...params}
                                                label="CETIP"
                                                error={cetipError}
                                                InputLabelProps={{
                                                    shrink: !!cetipInput || !!cetipValue,
                                                }}
                                            />
                                        )}
                                    />

                                </Grid>
                                <Grid item xs={12} md={2} xl={2}>
                                    <Autocomplete
                                        freeSolo
                                        forcePopupIcon={true}
                                        disableClearable={false}

                                        value={versaoDocumentoValue}
                                        options={versoesDocumentoSelectOptions}
                                        loading={loadingVersoes}
                                        
                                        getOptionLabel={(option) => {
                                            if (typeof option === "string") return option
                                            return option.label || ""
                                        }}
                                        onChange={(event, newValue) => {
                                            // Se newValue for um objeto da lista, pegamos .value, 
                                            // se for digitação  livre, pegamos o próprio newValue
                                            const valorBruto = newValue?.value ?? newValue ?? ""
                                            const apenasNumeros = String(valorBruto).replace(/[^0-9]/g, "")
                                            setVersaoDocumentoValue(apenasNumeros)
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            const apenasNumeros = newInputValue.replace(/[^0-9]/g, "")
                                            setVersaoDocumentoValue(apenasNumeros)
                                        }}
                                        disabled={loadingVersoes}
                                        renderInput={(params) => (
                                            <TextFieldInput
                                                {...params}
                                                label="Versão Documento"
                                                InputLabelProps={{
                                                    ...params.InputLabelProps,
                                                    shrink: !!versaoDocumentoValue || (params.inputProps?.value && params.inputProps.value.length > 0)
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} container spacing={2} alignItems="center">
                                    <Grid item>
                                        <ButtonWithIcon
                                            onClick={filterCadastro}
                                            icon={<SearchIcon/>}
                                        >
                                            VERIFICAR
                                        </ButtonWithIcon>
                                    </Grid>

                                    <Grid item>
                                        <ButtonWithIcon
                                            onClick={() => {
                                                // Limpa os filtros
                                                setCetipInput("")
                                                setCetipValue("")
                                                setVersaoDocumentoValue("")
                                                setVersoesDocumentoOptions([])
                                                loadCadastrosEmAndamento()
                                            }}
                                            icon={<ClearIcon/>}
                                        >
                                            LIMPAR FILTRO
                                        </ButtonWithIcon>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                <br/>

                {/* Container para inicio do cadastro */}
                <Grid container spacing={3} direction="row">
                    {/* Item do leitor de OCR */}
                    <Grid item xs={12} md={8}>
                        <Paper sx={{p: 3, height: '100%', borderRadius: 0}}>
                            <Grid container direction="column" spacing={2}>
                                <Grid item container justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" component="span" color="common.white">
                                            LER DOCUMENTO OCR
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <ButtonWithIcon
                                            onClick={handleAbrirModal}
                                            icon={<ChatIcon/>}
                                        >
                                            EDITAR PROMPT
                                        </ButtonWithIcon>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} xl={12} sx={{width: '100%'}}>
                                    <GridRadioButton
                                        defaultRadioValue={tipoSelecionado}
                                        onChange={handleRadioChange}
                                        direction={"column"}
                                        columns={3}
                                        itemsPerColumn={2}
                                        title="Tipo de Documento"
                                        radioButtonItems={[
                                            {value: "a", label: "Termo de securitização"},
                                            {value: "b", label: "Tela CETIP corporate"},
                                            {value: "c", label: "Tela CETIP IF"},
                                            {value: "d", label: "Escritura de Debênture"},
                                            {value: "e", label: "Outras escrituras"},
                                            {value: "f", label: "Fluxo de eventos"},
                                        ]}
                                    />
                                </Grid>
                                <br/>
                                <Grid item xs={12} sx={{mt: 2}}>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleFileSelect}
                                        style={{display: "none"}}
                                        accept=".pdf,.png,.jpg,.jpeg"
                                    />

                                    {!ocrFile ? (
                                        <Box
                                            sx={dashedAreaStyle}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={handleDrop}
                                        >
                                            <ButtonWithIcon
                                                onClick={handleTriggerFileSelect}
                                                icon={<PlusSquareIcon/>}
                                            >
                                                SELECIONAR ARQUIVO
                                            </ButtonWithIcon>
                                            <Typography variant="body2" sx={{mt: 1, color: '#94a3b8'}}>
                                                Ou arraste e solte os arquivos aqui.
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <Box sx={selectedFileAreaStyle}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                flexGrow: 1,
                                                minWidth: 0,
                                                mr: 1
                                            }}>
                                                <FileIcon sx={{color: 'icon.main'}}/>
                                                <Typography variant="body1" sx={{
                                                    color: '#fff',
                                                    fontWeight: 400,
                                                }}>
                                                    {ocrFile.name}
                                                </Typography>
                                            </Box>

                                            <Box sx={{
                                                display: 'flex', gap: 1, flexShrink: 0,
                                                justifyContent: 'flex-end', flexGrow: {xs: 1, md: 0}
                                            }}>
                                                <ButtonWithIcon
                                                    onClick={handleUploadOCR}
                                                    icon={<CheckIcon sx={{fontSize: 18}}/>}
                                                    style={{
                                                        backgroundColor: 'transparent.white10',
                                                        borderColor: 'primary.main3',
                                                        color: '#e2e8f0',
                                                        padding: '6px 16px',
                                                        whiteSpace: 'nowrap',
                                                        fontSize: '0.8rem'
                                                    }}
                                                >
                                                    ENVIAR ARQUIVO
                                                </ButtonWithIcon>

                                                <ButtonWithIcon
                                                    onClick={handleRemoveFile}
                                                    icon={<TrashIcon sx={{fontSize: 18}}/>}
                                                    style={{
                                                        backgroundColor: 'transparent.white10',
                                                        borderColor: 'primary.main3',
                                                        color: '#e2e8f0',
                                                        padding: '6px 16px',
                                                        whiteSpace: 'nowrap',
                                                        fontSize: '0.8rem'
                                                    }}
                                                >
                                                    EXCLUIR ARQUIVO
                                                </ButtonWithIcon>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Item do cadastro manual */}
                    <Grid item xs={12} md={4}>
                        <Paper sx={{p: 3, height: '100%', borderRadius: 0}}>
                            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <Grid item sx={{mb: 12}}>
                                    <Typography variant="body1" component="span" color="common.white">
                                        CADASTRO MANUAL
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <ButtonWithIcon onClick={iniciaCadastroManual}>
                                        INICIAR CADASTRO MANUAL
                                    </ButtonWithIcon>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                <br/>

                {/* Lista de cadastros OCR */}
                <FormSectionAccordion
                    disableBorder
                    disableIcon
                    title={"DOCUMENTOS"}
                    header={
                        <>
                            {ocrStatus.map((item) =>
                                ocrStatusBadge(item.number, item.label, item.color)
                            )}
                        </>
                    }
                    defaultOpen={true}>
                    <Paper sx={{p: 3, borderRadius: 0}}>
                        <Box
                            sx={{
                                flex: 1,
                                overflowX: "auto",
                                width: "100%",
                                display: "block",
                            }}
                        >
                            <DataGridTable
                                columns={columnsOCR}
                                rows={rowsOCR}
                                pagination={[25, 50]}
                                disableDeleteColumn
                                pageSize={5}
                                pagitaion
                                loading={loadingTableOCR}
                                resetKey={`cadastro-motor-ocr`}
                            />
                        </Box>
                    </Paper>
                </FormSectionAccordion>

                <Grid item xs={12} md={4}>

                </Grid>
                <br/>

                {/* Lista de cadastros */}
                <Grid item xs={12} md={4}>
                    <Paper sx={{p: 3, borderRadius: 0}}>
                        <Box
                            sx={{
                                flex: 1,
                                overflowX: "auto",
                                width: "100%",
                                display: "block",
                            }}
                        >
                            <DataGridTable
                                columns={columns}
                                rows={rows}
                                pagination={pagination}
                                disableDeleteColumn
                                loading={loadingTable}
                                resetKey={`cadastro-motor`}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Box>
            <DuplicarModal
                open={modalDuplicarOpen}
                onClose={() => setModalDuplicarOpen(false)}
                rowOriginal={linhaSelecionada}
                onConfirm={handleConfirmarDuplicacao}
            />
            <EditarPromptModal
                open={modalEditarOpen}
                onClose={handleFecharModal}
                onConfirm={handleSalvarModal}
                textoInicial={promptFinalEnvio || promptAtual}
            />
        </SideBarLayout>
    )
}

export default MotorCadastroListPage
